<template>
  <div>
    <div class="row p-2">
      <div class="col-12 col-md-12 d-flex">
        <nav>
          <span>
            <b>Enter Payment Information</b>
          </span>
        </nav>
      </div>
    </div>
    <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
      <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <div class="input-group">
          <input type="text" name="checknumber" class="input-create" autocomplete="nope" required />
          <span class="bar"></span>
          <label for="source" class="label-create">Check Number</label>
        </div>
      </div>
      <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <div class="input-group">
          <input type="text" name="checknumber" class="input-create" autocomplete="nope" required />
          <span class="bar"></span>
          <label for="source" class="label-create">Check Payable to</label>
        </div>
      </div>
      <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <div class="input-group">
          <input
            type="text"
            name="oldTitle"
            data-vv-as="Amount"
            data-vv-scope="Amount"
            class="input-create"
            autocomplete="nope"
            required
          />
          <span class="bar"></span>
          <label for="source" class="label-create">Amount</label>
        </div>
      </div>
    </div>
    <div class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
      <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
        <div class="input-group">
          <small class="small-label">Check Date</small>
          <date-picker
            type="date"
            name="oldTitle"
            data-vv-as="Old Title"
            data-vv-scope="manageTitle"
            class="input-create dob"
            valuetype="format"
            autocomplete="nope"
          />
          <span class="bar"></span>
        </div>
      </div>
    </div>
    <center>
      <button type="submit" class="btn btn-secondary">Submit</button>
    </center>
    <br />
    <div class="row">
      <div class="col-lg-4">
        <div class="col-12 col-md-12 d-flex">
          <nav>
            <span>
              <b>DMV Fee Charged</b>
            </span>
          </nav>
        </div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
          <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <label for="source" class="col-form-label col-form-label-sm">Agent Fee</label>
          </div>
          <div
            class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
          >
            <label class="textright">$1682</label>
          </div>
        </div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
          <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <label for="source" class="col-form-label col-form-label-sm">Sales Tax</label>
          </div>
          <div
            class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
          >
            <label class="textright">$82</label>
          </div>
        </div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
          <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <label for="source" class="col-form-label col-form-label-sm">Registration Fee</label>
          </div>
          <div
            class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
          >
            <label class="textright">$168</label>
          </div>
        </div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
          <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <label for="source" class="col-form-label col-form-label-sm">Total</label>
          </div>
          <div
            class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
          >
            <label for="source" class="text-right">$2000</label>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center mr-lg-2">
          <nav>
            <span>
              <b>Actual Fee Paid</b>
            </span>
          </nav>
        </div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mt-lg-5"></div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mt-lg-5"></div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mt-lg-4"></div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
          <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"></div>
          <div
            class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
          >
            <input type="textbox" class="form-control input-sm" disabled />
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <nav>
            <span>
              <b>Owed to Lessee or LLp</b>
            </span>
          </nav>
        </div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mt-lg-5"></div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mt-lg-5"></div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mt-lg-4"></div>
        <div class="row row-cols-lg-2 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
          <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"></div>
          <div
            class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
          >
            <input type="textbox" class="form-control input-sm" disabled />
          </div>
        </div>
      </div>
    </div>
    <br />
    <center>
      <button type="submit" class="btn btn-secondary" @click="displayAllDeals">Back</button>
    </center>
  </div>
</template>
<script>
import { bus } from "../main";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    DatePicker
  },
  methods: {
    displayAllDeals() {
      this.selecteddeal = "";
    }
  }
};
</script>
<style scoped>
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
.input-create:focus {
  /* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078ff;
}

/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}

.textright {
  text-align: right;
}
</style>
